module.exports = __webpack_public_path__ + "img/10.851054cd.png";